import { createAction, props } from '@ngrx/store';
import { ChannelViewModel } from './components/channel-list-screen/channel-list-screen.view-model';

const feature = '[Channel list]';

export const fetchChannels = createAction(`${feature} fetch channels`);
export const fetchChannelsSuccess = createAction(`${feature} fetch channels success`, props<{ channels: ChannelViewModel[] }>());
export const fetchChannelsFail = createAction(`${feature} fetch channels fail`, props<{ errorMessage: string }>());

export const syncChannels = createAction(`${feature} sync channels`);
export const syncChannelsSuccess = createAction(`${feature} sync channels success`);
export const syncChannelsFail = createAction(`${feature} sync channels fail`, props<{ errorMessage: string }>());
